import { useEffect } from "react";
import PageContainer from "@components/layout/PageContainer";
import { useParams } from "react-router-dom";
import styles from "./style.module.scss";
import CategoryForm from "@components/forms/CategoryForm";

const CategoryAddEdit = () => {
  const params = useParams()
  const { id: categoryId } = params;

  useEffect(() => {
  }, []);

  return (
    <PageContainer
      containerClassName={styles.mainContainer}
      title={`${!categoryId ? 'Agregar' : 'Editar'} Categoria`}
      backUrl="/user/categories"
      primaryActions={[
        {
          actionTitle: "Guardar",
          formId: "categoryForm",
          type: "submit",
          color: "success"
        }
      ]}
    >
      <CategoryForm
        formId="categoryForm"
        id={categoryId}
        saveRedirectUrl="/user/categories"
      ></CategoryForm>

    </PageContainer>
  );
}

export default CategoryAddEdit;
